<template>
  <div class="profile-page">
    <van-nav-bar :title="xuanfeidata.xuanfei_name || $t('concubine.concubine')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="profile-scroll">
      <div class="media-section" v-if="xuanfeidata.video_url || allImages.length">
        <div class="section-title">
          <span>资料展示</span>
          <span>{{ mediaCount }} 项</span>
        </div>

        <div class="media-grid">
          <div v-if="xuanfeidata.video_url" class="media-tile video-thumb" @click="openVideo">
            <img v-if="mainImage" class="tile-img" :src="mainImage" />
            <div v-else class="empty-thumb"></div>
            <div class="media-type">视频</div>
            <div class="play-mask">
              <van-icon name="play-circle-o" />
            </div>
          </div>

          <div
            v-for="(item, index) in allImages"
            :key="index"
            class="media-tile"
            @click="openImage(item)"
          >
            <img class="tile-img" :src="item" />
            <div class="media-type">图片</div>
          </div>
        </div>
      </div>

      <div class="info-panel">
        <div class="title-row">
          <img v-if="mainImage" class="avatar" :src="mainImage" />
          <div class="title-copy">
            <div class="name">{{ xuanfeidata.xuanfei_name }}</div>
            <div class="subtitle" v-if="xuanfeidata.vo_title">{{ xuanfeidata.vo_title }}</div>
          </div>
        </div>

        <div class="info-list">
          <div class="info-line" v-if="xuanfeidata.address">
            <van-icon name="location-o" color="#ffb54a" />
            <span class="label">地区</span>
            <span class="value">{{ xuanfeidata.address }}</span>
          </div>
          <div class="info-line" v-if="xuanfeidata.money">
            <van-icon name="shield-o" color="#63d7a3" />
            <span class="label">保证金</span>
            <span class="value">{{ xuanfeidata.money }}</span>
          </div>
          <div class="info-line" v-if="xuanfeidata.sign">
            <van-icon name="edit" color="#d9c9ef" />
            <span class="label">签名</span>
            <span class="value">{{ xuanfeidata.sign }}</span>
          </div>
        </div>

        <div class="tags" v-if="formatTags(xuanfeidata.label).length">
          <span
            v-for="(tag, index) in formatTags(xuanfeidata.label)"
            :key="index"
            :style="tagStyle(index)"
          >{{ tag }}</span>
        </div>

        <van-button class="reserve-button" round block color="#ff4ea3" @click="yuyue">预约</van-button>
      </div>
    </div>

    <div class="image-preview" v-if="previewImage" @click="closeImage">
      <img :src="previewImage" />
    </div>

    <van-popup v-model="showVideoPlayer" class="video-popup" closeable>
      <video
        v-if="showVideoPlayer"
        class="video-player"
        :src="xuanfeidata.video_url"
        controls
        autoplay
      ></video>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xuanfeidata: {},
      previewImage: '',
      showVideoPlayer: false
    };
  },
  computed: {
    profileImages() {
      const images = this.xuanfeidata.img_url;
      if (Array.isArray(images)) {
        return images;
      }
      return images ? [images] : [];
    },
    mainImage() {
      return this.xuanfeidata.img_url2 || this.profileImages[0];
    },
    allImages() {
      const images = [...this.profileImages];
      if (this.xuanfeidata.img_url2 && !images.includes(this.xuanfeidata.img_url2)) {
        images.unshift(this.xuanfeidata.img_url2);
      }
      return images;
    },
    mediaCount() {
      return this.allImages.length + (this.xuanfeidata.video_url ? 1 : 0);
    }
  },
  methods: {
    back() {
      this.$router.push({ path: '/Home' });
    },
    openImage(image) {
      this.previewImage = image;
    },
    closeImage() {
      this.previewImage = '';
    },
    openVideo() {
      this.showVideoPlayer = true;
    },
    formatTags(tags) {
      if (Array.isArray(tags)) {
        return tags.filter(Boolean);
      }
      if (!tags) {
        return [];
      }
      if (typeof tags === 'string') {
        try {
          const parsedTags = JSON.parse(tags);
          if (Array.isArray(parsedTags)) {
            return parsedTags.filter(Boolean);
          }
        } catch (e) {
          return this.splitTags(tags);
        }
        return this.splitTags(tags);
      }
      return [];
    },
    splitTags(tags) {
      return tags
        .replace(/\uFF0C|\u3001|\u3002/g, ',')
        .split(/[,.|/\s]+/)
        .map(tag => tag.trim())
        .filter(Boolean);
    },
    tagStyle(index) {
      const colors = ['#e9476a', '#2dabd2', '#dea52b', '#8b63d9', '#24b47e', '#f06f3c'];
      return { backgroundColor: colors[index % colors.length] };
    },
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.xuanfeidata = res.data || {};
      });
    },
    yuyue() {
      const service = this.$store.getters.getBaseInfo;
      if (service && service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        const config = res.data || {};
        if (config.iskefu == 1 && config.kefu) {
          window.location.href = config.kefu;
        } else {
          this.$toast(this.$t('reservation.counselor'));
        }
      }).catch(() => {
        this.$toast(this.$t('reservation.counselor'));
      });
    }
  },
  created() {
    this.getxuanfeidata();
  }
};
</script>

<style lang="less" scoped>
.profile-page {
  min-height: 100vh;
  background: #29243d;
}

.profile-scroll {
  height: calc(100vh - 46px);
  overflow-y: auto;
  padding: 12px 12px 32px;
  box-sizing: border-box;
}

.media-section,
.info-panel {
  border-radius: 8px;
  background: #4f3460;
  color: #fff;
}

.media-section {
  padding: 12px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #eadff1;
  font-size: 24px;
}

.section-title span:first-child {
  color: #fff;
  font-size: 28px;
  font-weight: 600;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.media-tile {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  overflow: hidden;
  background: #1f1a30;
  cursor: pointer;
}

.tile-img,
.empty-thumb {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #1f1a30;
}

.media-type {
  position: absolute;
  left: 6px;
  top: 6px;
  padding: 3px 7px;
  border-radius: 999px;
  background: rgba(0, 0, 0, .48);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
}

.play-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .18);
  color: #fff;
  font-size: 58px;
}

.info-panel {
  margin-top: 12px;
  padding: 14px;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
  background: #1f1a30;
}

.title-copy {
  min-width: 0;
}

.name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.25;
}

.subtitle {
  margin-top: 4px;
  color: #eadff1;
  font-size: 23px;
  line-height: 1.35;
}

.info-list {
  margin-top: 14px;
  padding: 4px 0;
  border-top: 1px solid rgba(255, 255, 255, .12);
  border-bottom: 1px solid rgba(255, 255, 255, .12);
}

.info-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 9px 0;
  font-size: 24px;
  line-height: 1.35;
}

.label {
  flex: 0 0 72px;
  color: #d9c9ef;
}

.value {
  flex: 1;
  min-width: 0;
  color: #fff;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.tags span {
  padding: 8px 14px;
  border-radius: 999px;
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
}

.reserve-button {
  margin-top: 16px;
  height: 46px;
  font-size: 28px;
  font-weight: 700;
}

.image-preview {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, .9);
  box-sizing: border-box;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.video-popup {
  width: 92%;
  background: transparent;
}

.video-player {
  display: block;
  width: 100%;
  max-height: 78vh;
  border-radius: 8px;
  background: #000;
}
</style>
